export default __webpack_public_path__ + "static/media/arrow.c72aafe5.svg";